import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import { lazy, Suspense } from "react";
import { appInsightsReactPlugin } from "@entrilia/shared/logging";
import { getVariables } from "../../../../../../../variables";

const areDevToolsEnabled = () => getVariables().DEVELOPER_TOOLS === "true";

const DeveloperPanel = lazy(async () => {
  if (areDevToolsEnabled()) {
    return await import("./DeveloperPanel");
  }

  return { default: () => <></> };
});

export function DeveloperPanelWrapper() {
  if (!areDevToolsEnabled()) {
    return null;
  }

  return (
    <AppInsightsErrorBoundary onError={() => null} appInsights={appInsightsReactPlugin}>
      <Suspense fallback={null}>
        <DeveloperPanel />
      </Suspense>
    </AppInsightsErrorBoundary>
  );
}
